import { TrainingSessionAssignment } from './../training-session-assignment';
import { TrainingSession } from './../training-session';

export class TrainingSessionAssignmentBuilder {
    static build(sessionId, trainingSessionAssignmentVO): TrainingSessionAssignment {
        const trainingSession = new TrainingSessionAssignment();
        trainingSession.id = trainingSessionAssignmentVO.id;
        trainingSession.user = trainingSessionAssignmentVO.user;
        trainingSession.session = sessionId;
        trainingSession.dateDebut = trainingSessionAssignmentVO.dateDebut;
        trainingSession.dateFin = (typeof trainingSessionAssignmentVO.dateFin === 'undefined' ? null : trainingSessionAssignmentVO.dateFin);
        return trainingSession;
    }
}



// WEBPACK FOOTER //
// ./src/app/model/builder/training-session-assignment.ts